import { cn } from '@/lib/utils'

interface SectionHeadingProps {
  eyebrow?: string
  title: string
  lede?: string
  align?: 'left' | 'center'
  className?: string
}

/** Eyebrow + title + lede, shared by every public section for a consistent rhythm. */
export function SectionHeading({
  eyebrow,
  title,
  lede,
  align = 'left',
  className,
}: SectionHeadingProps) {
  return (
    <div
      className={cn(
        'max-w-2xl',
        align === 'center' && 'mx-auto text-center',
        className,
      )}
    >
      {eyebrow && (
        <p
          className={cn(
            'eyebrow mb-6 flex items-center gap-3',
            align === 'center' && 'justify-center',
          )}
        >
          <span aria-hidden className="h-px w-8 bg-primary" />
          {eyebrow}
        </p>
      )}
      <h2 className="text-sheen pb-1 text-4xl font-semibold leading-[1.02] tracking-[-0.04em] text-balance md:text-5xl">
        {title}
      </h2>
      {lede && (
        <p className="mt-6 text-lg leading-relaxed text-pretty text-[var(--color-text-secondary)]">
          {lede}
        </p>
      )}
    </div>
  )
}
